import React, { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container, Tabs } from '@itds/elements/index.js';

import ProductFeatures from './product_features/List.js';
import FormTags from './form_tags/List.js';

const Index = () => {
  const hash = window.location.hash;

  const [refresh, setRefresh] = useState(false);

  // update state to trigger refresh which changes highlighted tab
  useEffect(() => {
    setRefresh(false);
  }, [refresh]);

  return (
    <Container>
      <div style={{ display: 'flex' }}>
        <Tabs
          tabs={[
            {
              label: 'Product Features',
              to: ' ',
              isActive: !hash.includes('form_tags'),
              onClick: setRefresh.bind(null, true)
            },
            {
              label: 'Form Tags',
              to: 'form_tags',
              isActive: hash.includes('form_tags'),
              onClick: setRefresh.bind(null, true)
            }
          ]}
          vertical={true}
        />

        <div style={{ flex: 1, paddingLeft: 40 }}>
          <Routes>
            <Route element={<ProductFeatures />} index={true} />
            <Route element={<FormTags />} path='form_tags' />
          </Routes>
        </div>
      </div>
    </Container>
  );
};

export default Index;
